<ngx-spinner class=" z-auto" bdColor = "rgba(0,0,0,0.84)" size = "medium" color = "#038f98" type = "ball-clip-rotate-multiple" [fullScreen] = "true"><p style="color: white" >{{'GLOBAL.LABELS.LOADING' | translate}}</p></ngx-spinner>

<div class="p-8 text-white">
  <form [formGroup]="formUsers">
    <p *ngIf="!payroll">
      {{'GLOBAL.LABELS.USERS_AND_GROUPS' | translate}}
    </p>
    <p *ngIf="payroll">
      {{'PAYROLL.ASSIGN_USER' | translate}} "{{payroll.name}}"
    </p>
  <div class="grid grid-cols-1 gap-3">
    <div class="flex items-end justify-between flex-wrap">
      <div class="flex w-3/4">
        <oden-select class="w-3/12" (change)="getAthletes(1)"  *ngIf="user.id_rol == 3" label="Sucursal" formControlName="branch" [options]="branchSelectOptions" [selectVisible]="false" ></oden-select>
       
        <oden-input class="w-3/12" label="Búsqueda" formControlName="searchTerm" type="search" placeholder=""></oden-input>
        <oden-select *ngIf="typeData == 1 && user.id_rol >= 3 " class="w-3/12" (change)="getAthletes(1)"  label="Etiqueta" formControlName="tag" [options]="tagSelectOptions" ></oden-select>
        <!-- <oden-input class="w-3/12" (keyup)="searchUser()" label="Búsqueda" formControlName="searchTerm" type="search" placeholder=""></oden-input> -->
        <oden-select class="w-6/12" *ngIf="typeData == 1 && formUsers.value.userType == 6 && user.id_rol >= 3" (change)="getAthletes(1)" label="Filtros" formControlName="typeUsers" [options]="typeUsersOptions" ></oden-select>
      </div>
      <div class=" mt-5 flex gap-2 justify-end">
        <oden-button  class="px-1" (click)="back()" color="secondary" text="{{'GLOBAL.BUTTONS.CANCEL' | translate}}"></oden-button>
        <oden-button icon="checkmark-circle"  class="px-1" (click)="addUsersAndBack()" color="primary" text="{{'GLOBAL.BUTTONS.KEEP' | translate}}"></oden-button>
      </div>
    </div>
    <div *ngIf="userIdEditSelected !== 0" (click)="backToAssignAthletes(us)" class="cursor-pointer">
      <ion-icon
        name="arrow-back"
        class="text-xl text-white hover:text-yellow-300 m-auto"
      ></ion-icon>
      <span>Asignacion de atletas</span>
    </div>
    <div *ngIf="typeData == 1 && !onlyAthletes" class=" bg-jet-black-800">
      <ion-segment color="secondary" (click)="getAthletes(1)" formControlName="userType">
        <ion-segment-button
          class="hover:bg-jet-black-700 rounded-md hover:text-black"
          value="6"
          *ngIf="!payroll && user.id_rol == 3 || user.id_rol == 4 || user.id_rol == 5 || user.id_rol == 7 "
        >
          <ion-label class="text-xs text-white">{{'USERS.ATHLETES' | translate}}</ion-label>
        </ion-segment-button>
        <ion-segment-button class="hover:bg-jet-black-700 rounded-md hover:text-black" value="4"
          *ngIf="user.id_rol == 3">
          <ion-label class="text-xs text-white">{{'USERS.BRANCH_ADMIN' | translate}}</ion-label>
        </ion-segment-button>
        <ion-segment-button class="hover:bg-jet-black-700 rounded-md hover:text-black" value="5"
          *ngIf="user.id_rol == 3 || user.id_rol == 4">
          <ion-label class="text-xs text-white">{{'USERS.COACH' | translate}}</ion-label>
        </ion-segment-button>
        <ion-segment-button class="hover:bg-jet-black-700 rounded-md hover:text-black" value="7"
          *ngIf="user.id_rol == 3 || user.id_rol == 4">
          <ion-label class="text-xs text-white">{{'USERS.PAYMENT_BOX' | translate}}</ion-label>
        </ion-segment-button>
        <ion-segment-button class="hover:bg-jet-black-700 rounded-md hover:text-black" value="3"
          *ngIf="user.id_rol == 1 || user.id_rol == 2">
          <ion-label class="text-xs text-white">{{'USERS.CLIENT' | translate}}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>
   <!--  <div class="text-right">
      <oden-button  class="px-1" (click)="addUsersAndBack()" color="success" text="{{'Aceptar' | translate}}"></oden-button>
      <oden-button  class="px-1" (click)="back()" color="secondary" text="{{'GLOBAL.BUTTONS.CANCEL' | translate}}"></oden-button>
    </div> -->
    
  </div>
  
  <div class="mt-3 grid grid-cols-2 gap-1">
    <div  *ngIf="typeData == 1 && userIdEditSelected == 0">
      <p>{{'GLOBAL.SECTIONS.USERS' | translate}}</p>
      <div class=" h-96 w-full overflow-auto">
        <oden-table class="sticky w-full top-0 bg-jet-black-800">
          <oden-row >
            <oden-head>{{'GLOBAL.TABLE_FIELD.PHOTO' | translate}}</oden-head>
            <oden-head>{{'GLOBAL.TABLE_FIELD.NAME' | translate}}</oden-head>
            <oden-head></oden-head>
          </oden-row>
        </oden-table>
        <oden-table>
          <oden-row *ngFor="let us of users" class="border-row">
            <oden-cell class="grid grid-flow-col align-middle"> 
              <div class="p-auto mr-3" *ngIf="us.id_rol == 6">
                <oden-pill *ngIf="us.status.ACTIVO == true" text="." color="active"></oden-pill>
                  <oden-pill *ngIf="us.status.EXPIRADO == true" text="." color="expired"></oden-pill>
                  <oden-pill *ngIf="us.status.POR_EXPIRAR == true" text="." color="byExpired"></oden-pill>
              </div>
              <div>
                <img src="{{us.foto}}" class="w-10 h-10 m-auto rounded-full border border-jet-black-600">
              </div>
              <p  *ngIf="us.tag"> </p>
            </oden-cell>
            <oden-cell class="p-auto align-middle">
              <p >
                {{us.nombre_completo}}
              </p>
              <p class=" text-xs text-jet-black-600" *ngIf="us.usuario_membresia.length > 0 && us.id_rol == 6 && (user?.permissions?.show_data_user)"> Membresía:{{us.usuario_membresia[0].nombre}}</p>
              <p class=" text-xs text-jet-black-600" *ngIf="us.usuario_membresia.length == 0 && us.id_rol == 6 && (user?.permissions?.show_data_user)"> Sin membresías activas</p>
              <p class=" text-xs text-jet-black-600" *ngIf="us.tag">{{'GLOBAL.LABELS.TAG' | translate}}: {{us.tag.texto}}</p>
              
            </oden-cell>
            <oden-cell class=" p-auto align-middle">
              <ion-icon (click)="addUser(us)" name="add-circle" class="text-xl text-green-500 hover:text-yellow-300 cursor-pointer m-auto"></ion-icon>
            </oden-cell>
          </oden-row>
        </oden-table>
      </div>
     <!--    <oden-table >
          <div class="h-96 relative w-full overflow-auto">
            <div class="sticky top-0 bg-jet-black-800">
              <oden-row >
                <oden-head>{{'GLOBAL.TABLE_FIELD.PHOTO' | translate}}</oden-head>
                <oden-head>{{'GLOBAL.TABLE_FIELD.NAME' | translate}}</oden-head>
                <oden-head></oden-head>
              </oden-row>
            </div>
           
            <oden-row *ngFor="let us of users">
              <oden-cell class="grid grid-flow-col"> 
                <div class="p-auto mr-3">
                  <oden-pill *ngIf="us.status.ACTIVO == true" text="." color="active"></oden-pill>
                    <oden-pill *ngIf="us.status.EXPIRADO == true" text="." color="expired"></oden-pill>
                    <oden-pill *ngIf="us.status.POR_EXPIRAR == true" text="." color="byExpired"></oden-pill>
                </div>
                <div>
                  <img src="{{us.foto}}" class="w-10 h-10 m-auto rounded-full border border-jet-black-600">
                </div>
              </oden-cell>
              <oden-cell>
                <p>{{us.nombre_completo}}</p>
                <p class=" text-xs text-jet-black-600" *ngIf="us.usuario_membresia.length > 0"> {{'GLOBAL.LABELS.MEMBERSHIP' | translate}}: {{us.usuario_membresia[0].nombre}}</p>
                <p class=" text-xs text-jet-black-600" *ngIf="us.usuario_membresia.length == 0"> {{'GLOBAL.LABELS.NO_MEMBERSHIP' | translate}}</p>
              </oden-cell>
              <oden-cell>
                <ion-icon (click)="addUser(us)" name="add-circle" class="text-xl text-green-500 hover:text-yellow-300 cursor-pointer"></ion-icon>
              </oden-cell>
            </oden-row>
          </div>
          
        </oden-table> -->
      
      <div>
        <oden-pagination (changePaginator)="getAthletes($event)" [items]="5" [currentPage]="pagInfo?.currentPage" [totalPages]="pagInfo.totalPages" class="col-span-4"></oden-pagination>
      </div>
    </div>
    <div   *ngIf="typeData == 1">
      <p>{{'GLOBAL.LABELS.SELECTED_USERS' | translate}}</p>
      <div *ngIf=" usersSelect.length > 0" class="h-96 relative w-full overflow-auto">
        <oden-table class=" sticky top-0 bg-jet-black-800">
          <oden-row >
            <oden-head>{{'GLOBAL.TABLE_FIELD.PHOTO' | translate}}</oden-head>
            <oden-head>{{'GLOBAL.TABLE_FIELD.NAME' | translate}}</oden-head>
            <oden-head></oden-head>
          </oden-row>
        </oden-table>
        <oden-table>
          <oden-row *ngFor="let us of usersSelect" class="border-row">
            <oden-cell class="grid grid-flow-col align-middle">
              <div class="p-auto mr-3" *ngIf="us.id_rol == 6">
                <oden-pill *ngIf="us.status && us.status.ACTIVO == true" text="." color="active"></oden-pill>
                  <oden-pill *ngIf="us.status && us.status.EXPIRADO == true" text="." color="expired"></oden-pill>
                  <oden-pill *ngIf="us.status && us.status.POR_EXPIRAR == true" text="." color="byExpired"></oden-pill>
              </div>
              <div>
                <img src="{{us.foto}}" class="w-10 h-10 m-auto rounded-full border border-jet-black-600">
              </div>
              
              <p class=" text-xs text-jet-black-600" *ngIf="us.tag"></p>
            </oden-cell>
            <oden-cell class="p-auto align-middle">
              <p >
                {{
                  us.nombre_completo
                  ? us.nombre_completo
                  : us.nombre + ' ' + us.apellido_paterno + ' ' + us.apellido_materno
                }}
              </p>
              <p class=" text-xs text-jet-black-600" *ngIf="us.id_rol == 6 && us.usuario_membresia.length > 0"> Membresía:{{us.usuario_membresia[0].nombre}}</p>
              <p class=" text-xs text-jet-black-600" *ngIf="us.id_rol == 6 && us.usuario_membresia.length == 0"> Sin membresías activas</p>
              <p class=" text-xs text-jet-black-600" *ngIf="us.tag">{{'GLOBAL.LABELS.TAG' | translate}}: {{us.tag.texto}}</p>
              <div 
                *ngIf="us.templateGroups && us.templateGroups.length > 0"
                class="grid grid-cols-2"
              >
                <div
                  *ngFor="let template of us.templateGroups"
                  class="m-1"
                >
                  <oden-pill
                    text="{{template}}"
                  ></oden-pill>
                </div>
              </div>
            </oden-cell>
            <oden-cell
              class="align-middle"
              *ngIf="userIdEditSelected == 0"
            >
              <ion-icon
                name="pricetags"
                *ngIf="us.isShop && user.gimnasio.type == 'coach'"
                class="text-xl text-white hover:text-yellow-300 cursor-pointer z-10 mx-2"
                (click)="openMembershipDetails(us)"
              ></ion-icon>
              <ion-icon
                (click)="removeUser(us)"
                name="remove-circle"
                class="text-xl text-red-500 hover:text-yellow-300 cursor-pointer z-10"
              ></ion-icon>
              <ion-icon 
                *ngIf="onlyAthletes"
                (click)="editUserTemplate(us)"
                name="create"
                class="text-xl text-green-500 hover:text-yellow-300 cursor-pointer ml-2 z-10"
              ></ion-icon>
              <ion-icon
                *ngIf="onlyAthletes"
                (click)="editInitialRoutineUser(us)"
                name="settings"
                class="text-xl text-gray-500 hover:text-yellow-300 cursor-pointer ml-2 z-10"
              >
              </ion-icon>
              <div
                class="w-32 h-48 overflow-y-auto p-2 rounded-sm absolute bg-jet-black-800 z-50"
                *ngIf="userSelectDays && userSelectDays.id == us.id"
              >
                <div
                  class="border-b border-solid border-jet-black-200 cursor-pointer bg-jet-black-800"
                  *ngFor="let day of daysAdded"
                  (click)="selectDay(day)"
                >
                  Día {{day.dia}}
                </div>
              </div>
            </oden-cell>
            <oden-cell
              *ngIf="userIdEditSelected !== 0"
            >
              <oden-radio
                [checked]="true"
                class="mt-auto"
                label="&nbsp;"
                *ngIf="userIdEditSelected === us.id"
              ></oden-radio>
            </oden-cell>
          </oden-row>
        </oden-table>
      </div>
      <!-- <div *ngIf=" usersSelect.length > 0">
        <oden-table >
          <div class="h-96 relative w-full overflow-auto">
            <div class=" sticky top-0 bg-jet-black-800">
              <oden-row >
                <oden-head>{{'GLOBAL.TABLE_FIELD.PHOTO' | translate}}</oden-head>
                <oden-head>{{'GLOBAL.TABLE_FIELD.NAME' | translate}}</oden-head>
                <oden-head></oden-head>
              </oden-row>
            </div>
            <oden-row *ngFor="let us of usersSelect">
              <oden-cell class="grid grid-flow-col">
                <div class="p-auto mr-3">
                  <oden-pill *ngIf="us.status.ACTIVO == true" text="." color="active"></oden-pill>
                    <oden-pill *ngIf="us.status.EXPIRADO == true" text="." color="expired"></oden-pill>
                    <oden-pill *ngIf="us.status.POR_EXPIRAR == true" text="." color="byExpired"></oden-pill>
                </div>
                <div>
                  <img src="{{us.foto}}" class="w-10 h-10 m-auto rounded-full border border-jet-black-600">
                </div>
              </oden-cell>
              <oden-cell>
                <p>{{us.nombre_completo}}</p>
              </oden-cell>
              <oden-cell>
                <ion-icon (click)="removeUser(us)" name="remove-circle" class="text-xl text-red-500 hover:text-yellow-300 cursor-pointer"></ion-icon>
              </oden-cell>
            </oden-row>
          </div>
         
          
        </oden-table>
      </div> -->
      
      <p class="text-center" *ngIf=" usersSelect.length == 0">{{'GLOBAL.LABELS.NO_USERS' | translate}}</p>
    </div>
    <div  *ngIf="typeData == 2">
      <div>
        <p>{{'MESSAGES.GROUPS' | translate}}</p>
        <div class="h-96 relative w-full overflow-auto">
          <oden-table class=" w-full sticky top-0 bg-jet-black-800">
            <oden-row>
              <oden-head>{{'GLOBAL.TABLE_FIELD.NAME' | translate}}</oden-head>
              <oden-head>{{'GLOBAL.TABLE_FIELD.ATHLETE' | translate}}</oden-head>
              <oden-head></oden-head>
            </oden-row>
          </oden-table>
          <oden-table>
            <oden-row *ngFor="let g of groups">
              <oden-cell>
                <p>{{g.nombre}}</p>
              </oden-cell>
              <oden-cell>
                <p class=" text-primary-1000">{{g.total_atletas}}</p>
              </oden-cell>
              <oden-cell>
                <ion-icon (click)="addGroup(g)" name="add-circle" class="text-xl text-green-500 hover:text-yellow-300 cursor-pointer"></ion-icon>
              </oden-cell>
            </oden-row>
          </oden-table>
        </div>
      <!--   <oden-table >
          <div class="h-96 relative w-full overflow-auto">
            <div class=" sticky top-0 bg-jet-black-800">
              <oden-row>
                <oden-head>{{'GLOBAL.TABLE_FIELD.NAME' | translate}}</oden-head>
                <oden-head>{{'GLOBAL.TABLE_FIELD.ATHLETE' | translate}}</oden-head>
                <oden-head></oden-head>
              </oden-row>
            </div>
            <oden-row *ngFor="let g of groups">
              <oden-cell>
                <p>{{g.nombre}}</p>
              </oden-cell>
              <oden-cell>
                <p class=" text-primary-1000">{{g.total_atletas}}</p>
              </oden-cell>
              <oden-cell>
                <ion-icon (click)="addGroup(g)" name="add-circle" class="text-xl text-green-500 hover:text-yellow-300 cursor-pointer"></ion-icon>
              </oden-cell>
            </oden-row>
          </div>
        </oden-table> -->
      </div>
      
      <div>
        <oden-pagination (changePaginator)="getAthletes($event)" [items]="5" [currentPage]="pagInfo?.currentPage" [totalPages]="pagInfo.totalPages" class="col-span-4"></oden-pagination>
      </div>
    </div>
    <div  *ngIf="typeData == 2">
      <p>{{'MESSAGES.GROUPS' | translate}} seleccionados</p>
      <div *ngIf="groupsSelect.length > 0">
        <div class="h-96 relative w-full overflow-auto">
          <oden-table class=" w-full sticky top-0 bg-jet-black-800">
            <oden-row>
              <oden-head>{{'GLOBAL.TABLE_FIELD.NAME' | translate}}</oden-head>
              <oden-head>{{'GLOBAL.TABLE_FIELD.ATHLETE' | translate}}</oden-head>
              <oden-head></oden-head>
            </oden-row>
          </oden-table>
          <oden-table>
            <oden-row *ngFor="let g of groupsSelect">
              <oden-cell>
                <p>{{g.nombre}}</p>
              </oden-cell>
              <oden-cell>
                <p class=" text-primary-1000">{{g.total_atletas}}</p>
              </oden-cell>
              <oden-cell>
                <ion-icon (click)="removeGroup(g)" name="remove-circle" class="text-xl text-red-700 hover:text-yellow-300 cursor-pointer"></ion-icon>
              </oden-cell>
            </oden-row>
          </oden-table>
        </div>
        <!-- <oden-table >
          <div class="h-96 relative w-full overflow-auto">
            <div class=" sticky top-0 bg-jet-black-800">
              <oden-row>
                <oden-head>{{'GLOBAL.TABLE_FIELD.NAME' | translate}}</oden-head>
                <oden-head>{{'GLOBAL.TABLE_FIELD.ATHLETE' | translate}}</oden-head>
                <oden-head></oden-head>
              </oden-row>
            </div>
            <oden-row *ngFor="let g of groupsSelect">
              <oden-cell>
                <p>{{g.nombre}}</p>
              </oden-cell>
              <oden-cell>
                <p class=" text-primary-1000">{{g.total_atletas}}</p>
              </oden-cell>
              <oden-cell>
                <ion-icon (click)="deleteGroup(g)" name="add-circle" class="text-xl text-green-500 hover:text-yellow-300 cursor-pointer"></ion-icon>
              </oden-cell>
            </oden-row>
          </div>

        </oden-table> -->
      </div>
     
        <p class="text-center" *ngIf=" groupsSelect.length == 0">{{'GLOBAL.LABELS.NO_GROUPS_SELECTED' | translate}}</p>
    </div>

    <!-- Sección para personalizar día del template para el usuario seleccionado -->
    <div *ngIf="userIdEditSelected !== 0">
      <h3>Personalizar entrenamiento</h3>
      <div class="mt-1 h-96 overflow-y-auto">
        <div>
          <form [formGroup]="formularioRoutine">
            <oden-card class="text-white">
              <oden-card-content class="grid grid-cols-1 gap-4">
                <div class="grid w-full justify-end">
                  <div>
                    <oden-button (click)="updateRoutine()" color="oden" text="Actualizar"></oden-button>
                  </div>
                </div>
                <div>
                  <div class="grid grid-cols-3 gap-3 relative">
                    <div class=" col-span-2"> 
                      <oden-input formControlName="nombre" type="text" label="Nombre" placeholder="Nombre" emojis="{{emojis}}"></oden-input>
                    </div>
          
                    <div class=" col-span-3 grid grid-cols-3">
                      <p class=" text-sm text-jet-black-400 col-span-2">Descripción</p>
                      <textarea formControlName="descripcion"  class=" text-sm bg-jet-black-800 px-2 col-span-2 h-20 w-full text-white" placeholder="Ej. Este entrenamiento esta diseñado para marcar el abdomen"></textarea>
                    </div>                  
          
                    <div class="col-span-3">
                      <p *ngIf="routine.rondas && routine.rondas.length > 0" >Secciones</p>
                      <div class="grid grid-cols-5 py-4 border-b-2 border-gray-600" *ngFor="let ronda of routine.rondas; let i = index">
                        <oden-input id="N{{ronda.id}}" formControlName="names{{ronda.id}}" type="text" label="Nombre de la sección" placeholder="Nombre"></oden-input>
                        <oden-select
                          [selectVisible]="false"
                          (change)="changeTSeccion(ronda)"
                          [options]="selectOptionRound"
                          label="Tipo de sección"
                          formControlName="tseccion{{ronda.id}}"
                        ></oden-select>
                        <oden-select [selectVisible]="false" (change)="changeTResultado(ronda)" [options]="selectOptionUnidad" label="Tipo de resultado" formControlName="tresultado{{ronda.id}}"></oden-select>
                        
                        <div class="mt-6 text-primary-1000 ">
                          &nbsp;
                        </div>
                        <div class="relative z-10 flex items-end  mt-6 text-right justify-end">
                          <oden-button
                            (click)="addVideo(ronda)"
                            color="onlyIcon"
                            classIcon="blue"
                            icon="videocam"
                            class="pr-2"
                          >
                          </oden-button>
                          <oden-button (click)="upSection(ronda)" *ngIf="i != 0" tooltip="subir sección" color="onlyIcon" classIcon="blue" icon="arrow-up-circle"></oden-button>
                          <oden-button (click)="downSection(ronda)" *ngIf="i != (routine.rondas.length-1)" tooltip="bajar sección" color="onlyIcon" classIcon="blue" icon="arrow-down-circle"></oden-button>
                          <oden-button (click)="openEmojisPop(ronda)" color="onlyIcon" classIcon="blue" icon="happy-outline"></oden-button>
                          <oden-button (click)="copySeccion(ronda)" tooltip="copiar sección" color="onlyIcon" classIcon="blue" icon="copy"></oden-button>
                          <oden-button (click)="removeSeccion(ronda)" tooltip="eliminar sección" color="onlyIcon" classIcon="red" icon="trash"></oden-button>
                          <!-- <ion-icon (click)="upSection(ronda)" *ngIf="i != 0" class="text-2xl ml-1 cursor-pointer hover:text-yellow-300 text-primary-1000 " name="arrow-up-circle"></ion-icon>                
                          <ion-icon (click)="downSection(ronda)" *ngIf="i != (routine.rondas.length-1)" class="text-2xl ml-1 cursor-pointer hover:text-yellow-300 text-primary-1000 "  name="arrow-down-circle"></ion-icon>
                          <ion-icon (click)="copySeccion(ronda)" class=" text-2xl cursor-pointer hover:text-yellow-300 text-primary-1000" name="copy"></ion-icon>
                          <ion-icon (click)="removeSeccion(ronda)" class=" text-2xl cursor-pointer hover:text-yellow-300 text-red-500" name="trash"></ion-icon> -->
                        </div>
                        <div class=" col-span-5 my-3" [ngClass]="(0 == i % 2 ? 'bg-jet-black-100':' bg-jet-black-500')">
                          <div class=" h-56 border border-transparent text-black editor" id="editor{{ronda.id}}">
                          </div>
                        </div>
                        <div class="col-span-5 text-sm"> <!--Opciones avanzadas-->
                          <div class="grid grid-cols-1" *ngIf="ronda.id_tipo_ronda < 7">
                            <span (click)="ronda.viewMore = !ronda.viewMore" class=" text-primary-1000 cursor-pointer hover:text-yellow-300">Opciones avanzadas <ion-icon name="arrow-down" *ngIf=" !ronda.viewMore || ronda.viewMore == false"></ion-icon> <ion-icon name="arrow-up" *ngIf="ronda.viewMore == true"></ion-icon></span>
                            <div class="mt-3" *ngIf="ronda.viewMore == true">
                              <div class="grid grid-cols-3" ><!--por tiempo-->
                                <oden-input *ngIf="ronda.id_tipo_ronda == 1 || ronda.id_tipo_ronda == 6 " formControlName="secctlimite{{ronda.id}}" type="number" min="0" label="Tiempo limite" placeholder="Minutos Ej. 15"></oden-input>
                                <oden-input *ngIf="ronda.id_tipo_ronda == 5 || ronda.id_tipo_ronda == 1" formControlName="seccsets{{ronda.id}}" type="number" min="0" label="Rounds/Sets" placeholder="Ej. 5"></oden-input>
                              </div>
                             
                              <div class="bg-jet-black-700 text-center text-jet-black-400 uppercase rounded-t-lg py-1 mb-2 grid grid-cols-5 gap-1 font-bold my-3" *ngIf="ronda.id_tipo_ronda == 1"><!-- por tiempo-->
                                <p>Ejercicio</p>
                                <p>Repeticiones</p>
                                  <p>Intensidad/Peso</p>
                                  <p>Unidad</p>
                                  <p></p>
                                </div>
                                <div class="bg-jet-black-700 text-center text-jet-black-400 uppercase rounded-t-lg py-1 mb-2 grid grid-cols-6 gap-1 font-bold my-3" *ngIf="ronda.id_tipo_ronda == 2"><!-- por fuerza-->
                                  <p>Ejercicio</p>
                                  <p>Sets</p>
                                  <p>Repeticiones</p>
                                  <p>Intensidad/Peso</p>
                                  <p>Unidad</p>
                                  <p></p>
                                </div>
                                <div class="bg-jet-black-700 text-center text-jet-black-400 uppercase rounded-t-lg py-1 mb-2 grid grid-cols-6 gap-1 font-bold my-3" *ngIf="ronda.id_tipo_ronda == 3"><!-- por distancia-->
                                  <p>Ejercicio</p>
                                  <p>Repeticiones</p>
                                  <p>Intensidad/Peso</p>
                                  <p>Unidad</p>
                                  <p>Tiempo limite</p>
                                  <p></p>
                                </div>
                                <div class="bg-jet-black-700 text-center text-jet-black-400 uppercase rounded-t-lg py-1 mb-2 grid grid-cols-5 gap-1 font-bold my-3" *ngIf="ronda.id_tipo_ronda == 4"><!-- por calidad-->
                                  <p>Ejercicio</p>
                                  <p>Sets</p>
                                  <p>Repeticiones</p>
                                  <p></p>
                                </div>
                                <div class="bg-jet-black-700 text-center text-jet-black-400 uppercase rounded-t-lg py-1 mb-2 grid grid-cols-6 gap-1 font-bold my-3" *ngIf="ronda.id_tipo_ronda == 5"><!-- por intervalos-->
                                  <p>Ejercicio</p>
                                  <p>Intensidad/Peso</p>
                                  <p>Unidad</p>
                                  <p>Tiempo trabajo</p>
                                  <p>Tiempo descanso</p>
                                  <p></p>
                                </div>
                                <div class="bg-jet-black-700 text-center text-jet-black-400 uppercase rounded-t-lg py-1 mb-2 grid grid-cols-5 gap-1 font-bold my-3" *ngIf="ronda.id_tipo_ronda == 6"><!-- por amrap-->
                                  <p>Ejercicio</p>
                                  <p>Repeticiones</p>
                                  <p>Intensidad/Peso</p>
                                  <p>Unidad</p>
                                  <p></p>
                                </div>
                                <div class=" my-3" *ngFor="let ej of ronda.ejercicios"><!--ejercicios-->
                                <div class=" grid grid-cols-5 gap-1" *ngIf="ronda.id_tipo_ronda == 1 || ronda.id_tipo_ronda == 6" > <!--form ejercicios-->
                                  <div class=" p-auto">
                                    <div class="px-2">
                                      <img class=" m-auto" src="{{ej.ejercicio.banner}}">
                                    </div>
                                     <p class=" text-center font-bold"> {{ej.ejercicio.nombre}}</p>
                                  </div>
                                  <oden-input formControlName="rep{{ej.ejercicio.id}}" type="number" min="0" placeholder="Ej. 5"></oden-input>
                                  <oden-input formControlName="int{{ej.ejercicio.id}}" type="text"  min="0" placeholder="Ej. 45/30"></oden-input>
                                  <oden-select [selectVisible]="false" [options]="selectOptionUnidadSection" [selectVisible]="false"
[selectVisible]="false" formControlName="unidad{{ej.ejercicio.id}}"></oden-select> <!-- (click)="changeTipoEntrenamiento()"-->
                                  <div class="text-center mt-3">
                                    <ion-icon class=" text-red-500 cursor-pointer hover:text-yellow-300 text-2xl" name="trash"  (click)="deleteExercise(ej,ronda.ejercicios)"></ion-icon>
                                  </div>
                                </div>
                                <div class=" grid grid-cols-6 gap-1" *ngIf="ronda.id_tipo_ronda == 3" > <!--form ejercicios-->
                                  <div class=" p-auto">
                                    <div class="px-2">
                                      <img class=" m-auto" src="{{ej.ejercicio.banner}}">
                                    </div>
                                     <p class=" text-center font-bold"> {{ej.ejercicio.nombre}}</p>
                                  </div>
                                  <oden-input formControlName="rep{{ej.ejercicio.id}}" type="number" min="0" placeholder="Ej. 5"></oden-input>
                                  <oden-input formControlName="int{{ej.ejercicio.id}}" type="text" min="0" placeholder="Ej. 45/30"></oden-input>
                                  <oden-select [selectVisible]="false" [options]="selectOptionUnidadSection" [selectVisible]="false"
[selectVisible]="false" formControlName="unidad{{ej.ejercicio.id}}"></oden-select> <!-- (click)="changeTipoEntrenamiento()"-->
                                  <oden-input formControlName="tlimite{{ej.ejercicio.id}}" type="number" min="0" placeholder="(Segundos) Ej. 30"></oden-input>
                                  <div class="text-center mt-3">
                                    <ion-icon class=" text-red-500 cursor-pointer hover:text-yellow-300 text-2xl" name="trash"  (click)="deleteExercise(ej,ronda.ejercicios)"></ion-icon>
                                  </div>
                                </div>
                                <div class=" grid grid-cols-6" *ngIf="ronda.id_tipo_ronda == 2" > <!--form ejercicios-->
                                  <div class=" p-auto">
                                    <div class="px-2">
                                      <img class=" m-auto" src="{{ej.ejercicio.banner}}">
                                    </div>
                                     <p class=" text-center font-bold"> {{ej.ejercicio.nombre}}</p>
                                  </div>
                                  <oden-input formControlName="sets{{ej.ejercicio.id}}" type="number" min="0" placeholder="Ej. 5"></oden-input>
                                  <oden-input formControlName="rep{{ej.ejercicio.id}}" type="number"min="0" placeholder="Ej. 5"></oden-input>
                                  <oden-input formControlName="int{{ej.ejercicio.id}}" type="text" min="0" placeholder="Ej. 45/30"></oden-input>
                                  <oden-select [selectVisible]="false" [options]="selectOptionUnidadSection" [selectVisible]="false"
[selectVisible]="false" formControlName="unidad{{ej.ejercicio.id}}"></oden-select> <!-- (click)="changeTipoEntrenamiento()"-->
                                  <div class="text-center mt-3">
                                    <ion-icon class=" text-red-500 cursor-pointer hover:text-yellow-300 text-2xl" name="trash"  (click)="deleteExercise(ej,ronda.ejercicios)"></ion-icon>
                                  </div>
                                </div>
                                <div class=" grid grid-cols-5" *ngIf="  ronda.id_tipo_ronda == 4 " > <!--form ejercicios-->
                                  <div class=" p-auto">
                                    <div class="px-2">
                                      <img class=" m-auto" src="{{ej.ejercicio.banner}}">
                                    </div>
                                     <p class=" text-center font-bold"> {{ej.ejercicio.nombre}}</p>
                                  </div>
                                  <oden-input formControlName="sets{{ej.ejercicio.id}}" type="number" min="0" placeholder="Ej. 5"></oden-input>
                                  <oden-input formControlName="rep{{ej.ejercicio.id}}" type="number" min="0" placeholder="Ej. 5"></oden-input>
                                  <div class="text-center mt-3">
                                    <ion-icon class=" text-red-500 cursor-pointer hover:text-yellow-300 text-2xl" name="trash"  (click)="deleteExercise(ej,ronda.ejercicios)"></ion-icon>
                                  </div>
                                </div>
                                <div class=" grid grid-cols-6" *ngIf="  ronda.id_tipo_ronda == 5 " > <!--form ejercicios-->
                                  <div class=" p-auto">
                                    <div class="px-2">
                                      <img class=" m-auto" src="{{ej.ejercicio.banner}}">
                                    </div>
                                     <p class=" text-center font-bold"> {{ej.ejercicio.nombre}}</p>
                                  </div>
                                 
                                  <oden-input formControlName="int{{ej.ejercicio.id}}" type="text" min="0" placeholder="Ej. 45/30"></oden-input>
                                  <oden-select [selectVisible]="false" [options]="selectOptionUnidadSection" [selectVisible]="false"
[selectVisible]="false" formControlName="unidad{{ej.ejercicio.id}}"></oden-select> <!-- (click)="changeTipoEntrenamiento()"-->
                                  <oden-input formControlName="ttrabajo{{ej.ejercicio.id}}" type="number" min="0" placeholder="(Segundos) Ej. 30"></oden-input>
                                  <oden-input formControlName="tdescanso{{ej.ejercicio.id}}" type="number" min="0" placeholder="(Segundos) Ej. 30"></oden-input>
                                  <div class="text-center mt-3">
                                    <ion-icon class=" text-red-500 cursor-pointer hover:text-yellow-300 text-2xl" name="trash"  (click)="deleteExercise(ej,ronda.ejercicios)"></ion-icon>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-10">
                                <oden-button (click)="addExercise(ronda)" class="mt-2" text="Añadir ejercicios"></oden-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-full col-span-3 py-1 z-30">
                      <div class="flex flex-row">
                        <oden-button (click)="addSeccion(null)" color="oden" text="Agregar sección"></oden-button>
                        <oden-button (click)="addWodLibrary()" color="oden" class="ml-2" text="Añadir de biblioteca"></oden-button>
                      </div>
                    </div>
          
          
                    <!--div *ngIf="user.gimnasio.paquete == 'paypal'" class="col-span-3"><--grupos y atletas || user.id_rol > 2-->
                    <div class="col-span-3" *ngIf="canCreateGroups">
                      <div class=" col-span-5 grid grid-cols-2">
                        <div >
                          <oden-checkbox (change)="changeAtletas()" class="mt-auto" label="¿Este entrenamiento es para atletas especificos?" formControlName="wod_especificos"></oden-checkbox>
                        </div>
                        <div *ngIf="routine.wod_especificos == true" class="col-span-2 grid grid-cols-2 gap-1 text-sm">
                          <div class=" flex flex-col">
                            <oden-select [selectVisible]="false" (click)="searchUser()" [options]="branchSelectOptions" [selectVisible]="false" label="Sucursal" formControlName="branch"></oden-select>
                            <!--(change)="searchUser()"-->  <oden-input   formControlName="search" type="search" label="Buscar atletas" placeholder="Búsqueda"></oden-input>
                            <div class=" max-h-48 overflow-y-auto mt-4 relative" *ngIf="users.length > 0">
                              <oden-table class=" w-full sticky top-0 bg-jet-black-800 z-50">
                                <oden-row>
                                  <oden-head class="w-15"></oden-head>
                                  <oden-head class="w-56">{{'Nombre' | translate}}</oden-head>
                                  <oden-head>Membresia</oden-head>
                                  <oden-head></oden-head>
                                </oden-row>
                              </oden-table>
                                <oden-table>
                                  <oden-row *ngFor="let atls of users" >
                                    <oden-cell class="relative w-15">
                                      <img class="h-10 w-10 rounded-full m-auto absolute top-0 bottom-0" src="{{atls.foto}}">
                                    </oden-cell>
                                    <oden-cell class="w-56">
                                      <p>{{atls.nombre_completo}}</p>
                                    </oden-cell>
                                    <oden-cell>
                                      <p *ngIf="atls.membresias_activas.length == 0 && (user?.permissions?.show_data_user)"> No tiene membresías</p>
                                      <p *ngIf="atls.membresias_activas.length > 0 && (user?.permissions?.show_data_user)"> Membresía: {{ atls.membresias_activas[atls.membresias_activas.length-1].nombre }} - {{ atls.membresias_activas[atls.membresias_activas.length-1].tipo_membresia.nombre }}</p>
                                    </oden-cell>
                                    <oden-cell>
                                      <ion-icon (click)="addUsers(atls)" class=" text-primary-500 cursor-pointer hover:text-yellow-300 text-center" name="person-add"></ion-icon>
                                    </oden-cell>
                                  </oden-row>
                                </oden-table>
                              <!-- <div *ngFor="let atls of users" class="grid grid-cols-12 gap-1">
                                <div class=" col-span-1">
                                  <img class="h-10 w-10 rounded-full m-auto" src="{{atls.foto}}">
                                </div>
                                <div class=" col-span-5">
                                  <p>{{atls.nombre_completo}}</p>
                                </div>
                                <div class=" col-span-5">
                                  <p *ngIf="atls.membresias_activas.length == 0"> No tiene membresías</p>
                                  <p *ngIf="atls.membresias_activas.length > 0"> Membresía: {{ atls.membresias_activas[atls.membresias_activas.length-1].nombre }} - {{ atls.membresias_activas[atls.membresias_activas.length-1].tipo_membresia.nombre }}</p>
                                </div>
                                <div class=" col-span-1">
                                  <ion-icon (click)="addUsers(atls)" class=" text-primary-500 cursor-pointer hover:text-yellow-300 text-center" name="person-add"></ion-icon>
                                </div>
                              </div> -->
                                  
                            </div>
                            <div class="mt-3" *ngIf="usersA.length > 0">
                              <p class="mb-3">Atletas asignados</p>
                              <div class=" mt-4 max-h-48 overflow-y-auto relative">
                                <oden-table class=" w-full sticky top-0 bg-jet-black-800 z-50">
                                  <oden-row>
                                    <oden-head class="w-15"></oden-head>
                                    <oden-head class="w-56">{{'Nombre' | translate}}</oden-head>
                                    <oden-head>Membresia</oden-head>
                                    <oden-head></oden-head>
                                  </oden-row>
                                </oden-table>
                                  <oden-table>
                                    <oden-row *ngFor="let atls of usersA">
                                      <oden-cell class="w-15 relative">
                                        <img class="h-10 w-10 rounded-full m-auto absolute top-0 bottom-0" src="{{atls.foto}}">
                                      </oden-cell>
                                      <oden-cell class="w-56">
                                        <p>{{atls.nombre}} {{atls.apellido_paterno}} {{atls.apellido_materno}}</p>
                                      </oden-cell>
                                      <oden-cell>
                                        <p *ngIf=" atls.membresias_activas && atls.membresias_activas.length == 0 && (user?.permissions?.show_data_user)"> No tiene membresías</p>
                                        <p *ngIf=" atls.membresias_activas && atls.membresias_activas.length > 0 && (user?.permissions?.show_data_user)"> Membresía: {{ atls.membresias_activas[atls.membresias_activas.length-1].nombre }} - {{ atls.membresias_activas[atls.membresias_activas.length-1].tipo_membresia.nombre }}</p>
                                      </oden-cell>
                                      <oden-cell>
                                        <ion-icon (click)="removeUser(atls)" class=" text-red-500 cursor-pointer hover:text-yellow-300 text-center" name="close-circle"></ion-icon>
                                      </oden-cell>
                                    </oden-row>
                                  </oden-table>
                                <!-- <div *ngFor="let atls of usersA" class=" grid grid-cols-12 mb-2 gap-1">
                                  <div class=" col-span-1">
                                    <img class="h-10 w-10 rounded-full m-auto" src="{{atls.foto}}">
                                  </div>
                                  <div class=" col-span-5">
                                    <p>{{atls.nombre}} {{atls.apellido_paterno}} {{atls.apellido_materno}}</p>
                                  </div>
                                  <div class=" col-span-5">
                                    <p *ngIf=" atls.membresias_activas && atls.membresias_activas.length == 0"> No tiene membresías</p>
                                    <p *ngIf=" atls.membresias_activas && atls.membresias_activas.length > 0"> Membresía: {{ atls.membresias_activas[atls.membresias_activas.length-1].nombre }} - {{ atls.membresias_activas[atls.membresias_activas.length-1].tipo_membresia.nombre }}</p>
                                  </div>
                                  <div class=" col-span-1">
                                    <ion-icon (click)="removeUser(atls)" class=" text-red-500 cursor-pointer hover:text-yellow-300 text-center" name="close-circle"></ion-icon>
                                  </div>
                                </div> -->
                              </div>
                              <oden-checkbox
                                class="m-2"
                                label="¿Crear grupo con estos atletas?"
                                formControlName="crear_grupo"
                              ></oden-checkbox>
                              <oden-input type="text" placeholder="Nombre del grupo" label="Nombre del grupo (*)" formControlName="nombre_grupo" *ngIf="formRoutine.value.crear_grupo"></oden-input>
                            </div>
                          </div>
                          <div class="flex flex-col">
                           <!--(change)="getGroups()"-->  <oden-input   formControlName="searchG" type="search" label="Buscar Grupos" placeholder="Búsqueda"></oden-input>
                            <div class="h-20"></div>
                            <div class=" h-48 overflow-y-scroll relative" *ngIf="groupsWod.length > 0">
                              <oden-table class=" w-full sticky top-0 bg-jet-black-800 z-50">
                                <oden-row>
                                  <oden-head class="w-56">{{'Nombre' | translate}}</oden-head>
                                  <oden-head>Atletas</oden-head>
                                  <oden-head></oden-head>
                                </oden-row>
                              </oden-table>
                                <oden-table>
                                  <oden-row *ngFor="let gr of groupsWod">                        
                                    <oden-cell class="w-56">
                                      <p>{{gr.nombre}}</p>
                                    </oden-cell>
                                    <oden-cell class="w-56">
                                      <p class=" text-primary-1000">Atletas: {{gr.atletas.length}}</p>
                                    </oden-cell>
                                    <oden-cell>
                                      <ion-icon (click)="addUsersByGroup(gr)" class=" text-green-500 cursor-pointer hover:text-yellow-300 text-center" name="add-circle"></ion-icon>
                                    </oden-cell>
                                    
                                  </oden-row>
                                </oden-table>
                              <!-- <div class="grid grid-cols-2" *ngFor="let gr of groupsWod">
                                <div><p>{{gr.nombre}} <span class=" text-primary-1000">Atletas: {{gr.atletas.length}}</span></p></div>
                                <div> <ion-icon (click)="addUsersByGroup(gr)" class=" text-green-500 cursor-pointer hover:text-yellow-300 text-center" name="add-circle"></ion-icon></div>
                              </div> -->
                            </div>
                          </div>
                        </div>
                      </div> 
                    </div>
                  </div>
                </div>
              </oden-card-content>
            </oden-card>
          </form>
        </div>
      </div>
    </div>
   
  </div>
</form>
</div>